import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import BriefPopularQueries from '../../../components/kea/widgets/BriefPopularQueries';
import { getAnalyticQueryPopular } from '../../../actions/Analytics';
import { defaultTimeframeList } from '../../../components/kea/DateRangePicker/timeframeList';

/**
 * Wrapper for BriefPopularQueries that auto-loads data for Home Screen
 */
const PopularQueriesWidget = ({
  queryPopular,
  currentShop,
  timeframe = defaultTimeframeList.last30days,
}) => {
  const dispatch = useDispatch();
  // Analytics is tenant-scoped: always start a fresh request when the shop changes.
  useEffect(() => {
    if (currentShop) {
      dispatch(getAnalyticQueryPopular(currentShop, timeframe));
    }
  }, [currentShop, timeframe, dispatch]);

  return (
    <BriefPopularQueries
      queryPopular={queryPopular}
      currentShop={currentShop}
    />
  );
};

PopularQueriesWidget.propTypes = {
  queryPopular: PropTypes.shape({
    isFetching: PropTypes.bool,
    isFetched: PropTypes.bool,
    data: PropTypes.array,
    error: PropTypes.any,
  }).isRequired,
  currentShop: PropTypes.string.isRequired,
  timeframe: PropTypes.object,
};

export default PopularQueriesWidget;
